/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Sec_MethodsInputs */

const en_funnel_demo_sec_methods = /** @type {(inputs: Funnel_Demo_Sec_MethodsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Methods`)
};

const es_funnel_demo_sec_methods = /** @type {(inputs: Funnel_Demo_Sec_MethodsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métodos`)
};

/**
* | output |
* | --- |
* | "Methods" |
*
* @param {Funnel_Demo_Sec_MethodsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_sec_methods = /** @type {((inputs?: Funnel_Demo_Sec_MethodsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Sec_MethodsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_sec_methods(inputs)
	return en_funnel_demo_sec_methods(inputs)
});